/**************************************************
 * Nombre:       Dialogo_Ver_Premio
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {useContext, useEffect, useState} from "react";
import {usuarioContext} from "../../App";
import {theme} from "../../Tema";
import {obtenerTotalPuntos} from "../../CodigoCliente/Puntos/obtenerTotalPuntos";

const Dialogo_Ver_Premio = ({cerrar, realizado, datos}) => {
    const cData = useContext(usuarioContext)
    const [totalPuntos, setTotalPuntos] = useState(0);


    useEffect(() => {

        obtenerTotalPuntos(cData.usuario.id).then((dox) => {
            setTotalPuntos(dox);

        })


    }, []);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            spacing={2}
        >


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center',}}>
                <Typography sx={{fontSize: 16, fontWeight: 400}}>Tus Puntos Actuales</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: -2.5}}>
                <Typography sx={{fontSize: 24, fontWeight: 600, color: theme.palette.primary.main}}>
                    {totalPuntos}
                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    spacing={0}
                >

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography
                            sx={{
                                fontWeight: 600,
                                fontSize: 14,
                                color: theme.palette.primary.main
                            }}>{'Nombre'}</Typography>

                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography
                            sx={{
                                fontWeight: 400,
                                lineHeight: 1.1
                            }}>{datos.nombre}</Typography>

                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                        <Typography sx={{
                            fontWeight: 600,
                            fontSize: 14,
                            color: theme.palette.primary.main
                        }}>Descripcion:</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography
                            sx={{
                                fontWeight: 400,
                                lineHeight: 1.1
                            }}>{datos.descripcion}</Typography>

                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                        <Typography sx={{fontWeight: 600, fontSize: 14, color: theme.palette.primary.main}}>Tiempo de
                            entrega:</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography
                            sx={{
                                fontWeight: 400,
                                lineHeight: 1.1
                            }}>{datos.tiempo}</Typography>

                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                        <Typography sx={{fontWeight: 600, fontSize: 14, color: theme.palette.primary.main}}>Puntos
                            necesarios:</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography
                            sx={{
                                fontWeight: 400,
                                lineHeight: 1.1
                            }}>{datos.valor} </Typography>

                    </Grid>

                </Grid>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-end'}}>
                <img src={datos.img} width={'90%'} height={'auto'}
                     style={{borderRadius: 10,}}/>
            </Grid>


        </Grid>
    )

}
export default Dialogo_Ver_Premio